const { axios } =
  await import(`./index.js?v=${Date.now()}`);
import "./_commonjsHelpers.js";
import "./recommended-products.js";
class LoadMore extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector(".js-load-more");
    const collectionContainer = document.querySelector(".collection__grid");
    const progressBar = this.querySelector(".js-loadmore-products");
    const textIndicator = this.querySelector(".loadmore-holder p");
    function waitForReviewsToLoad(attempts = 50) {
      document.querySelectorAll("article.product-button").forEach((el) => {
        el.classList.add("find_it_plp");
        el.querySelectorAll(".stamped-fa").forEach((star) => star.removeAttribute("style"));
      });
      setTimeout(() => waitForReviewsToLoad(attempts - 1), 500);
    }
    const handleSectionInjection = (parsedHTML) => {
      const additionalProducts = parsedHTML.querySelector(".collection__grid").innerHTML;
      const newProgressBar = parsedHTML.querySelector(".js-loadmore-products");
      const newTextIndicator = parsedHTML.querySelector(".loadmore-holder p").innerHTML;
      const newUrl = parsedHTML.querySelector(".js-load-more").dataset.url;
      parsedHTML.querySelectorAll(".product-button").length;
      parsedHTML.querySelectorAll(".collection-block-image--2").length;
      parsedHTML.querySelectorAll(".collection-block-image--1").length;
      collectionContainer.insertAdjacentHTML("beforeend", additionalProducts);
      progressBar.value = (newProgressBar == null ? void 0 : newProgressBar.value) || progressBar.value;
      if (progressBar.value >= progressBar.max) {
        progressBar.remove();
        textIndicator.remove();
        button.remove();
      } else {
        progressBar.value = newProgressBar.value;
        textIndicator.innerHTML = newTextIndicator;
        button.dataset.url = newUrl;
      }
      waitForReviewsToLoad();
      if (window.StampedFn) {
        if (typeof window.StampedFn.loadBadges === "function") {
          window.StampedFn.loadBadges();
        }
      }
    };
    const handleLoadMore = (url) => {
      axios.get(url).then((response) => {
        const parsedHTML = new DOMParser().parseFromString(Object.values(response.data)[0], "text/html");
        parsedHTML.querySelectorAll(".collection-block-image");
        if (parsedHTML) {
          handleSectionInjection(parsedHTML);
        }
      });
    };
    if (button) {
      button.addEventListener("click", () => {
        handleLoadMore(button.dataset.url);
      });
    }
  }
}
if (customElements.get("load-more") === void 0) {
  customElements.define("load-more", LoadMore);
}
